var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKura(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.37 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m78.33,68.03c7.76,0,14.04-6.29,14.04-14.04h-14.04s0,14.04,0,14.04Z",
    style: {
      fill: "#ec6730"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.37,82.08c0-7.76-6.29-14.04-14.04-14.04v14.04s14.04,0,14.04,0Z",
    style: {
      fill: "#ec6730"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0,106h75.93V30.07C34,30.07,0,64.06,0,106Zm54.4-52.01v-14.04c7.76,0,14.04,6.29,14.04,14.04h-14.04Z",
    style: {
      fill: "#ec6730"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.23,28.09c0-15.51-14.21-28.09-31.73-28.09v28.09s31.73,0,31.73,0Z",
    style: {
      fill: "#ec6730"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.55,28.09c0-7.76-6.29-14.04-14.04-14.04v14.04s14.04,0,14.04,0Z",
    style: {
      fill: "#ec6730"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKura);
export default __webpack_public_path__ + "static/media/kura.bf465550ea9105b338863a8cffbec83e.svg";
export { ForwardRef as ReactComponent };